<i18n lang="yaml">
  pt:
    project-name: "Nome do projeto"
    create-project: "Vamos lá"
    create-app: "Criar novo projeto"
    select-default-item: "Selecione uma opção"
    project-goal: "Para qual finalidade o projeto será usado?"
    tutorial-text: "Tutorial: Criando e configurando app do zero"
</i18n>

<template>
  <Modal id="createApp">
    <template #modal-title>
      {{ $t('create-app') }}
    </template>

    <template #modal-content>
      <FormRequest
        class="createapp"
        :rules="rules"
        @on-submit="createApp"
        @on-submitted="destiny"
      >
        <template #default="{ loading: busy }">
          <div class="createapp__wrapper">
            <BasicInput
              id="project-name"
              v-model="projectName"
              name="name"
              placeholder="Loja X"
              :title="$t('project-name')"
            />

            <input
              type="hidden"
              name="type"
              value="ecommerce"
            >

            <input
              type="hidden"
              name="status"
              value="1"
            >

            <p
              v-if="false"
              class="createapp__supporttext"
            >
              {{ supportText }}
            </p>

            <DefaultButton
              :busy="busy"
              type="submit"
              class="createapp__submit growing-effect w-100"
            >
              {{ $t('create-project') }}

              <ArrowNarrowRightIcon />
            </DefaultButton>

            <p class="createapp__helperlinks text-center mt-4 d-none">
              <a
                target="_blank"
                href="https://www.loom.com/share/13326c2b3b314c5a8751f2d1478cb69e"
              >
                {{ $t('tutorial-text') }}
              </a>
            </p>
          </div>
        </template>
      </FormRequest>
    </template>
  </Modal>
</template>

<script>
import { defineComponent } from 'vue'
import Modal from '../../../grid/modal/index'
import BasicInput from '../../../global/BasicInput'
import DefaultButton from '../../../global/Button'
import ArrowNarrowRightIcon from '../../../icons/ArrowNarrowRightIcon'
import FormRequest from '../../../core/form/Request.vue'
import { mapState, mapActions } from 'vuex'

export default defineComponent({
  name: 'ModalCreateApp',

  components: {
    Modal,
    BasicInput,
    FormRequest,
    DefaultButton,
    ArrowNarrowRightIcon
  },

  data () {
    return {
      projectName: '',

      selectedUsage: 'ecommerce',

      usageOptions: [{
        value: 'ecommerce',
        label: 'Vou usar em um E-commerce',
        helpText: 'Para utilizar o checkout da increazy no seu e-commerce você deverá vincular em uma das plataformas integradas a increazy. Experimente!'
      }, {
        value: 'institucional',
        label: 'Apenas institucional',
        helpText: 'Para você que precisa usar o checkout no seu site, app ou software. E também, para quem quer gerenciar assinaturas de clientes e receber pagamentos recorrentes. Comece agora mesmo!'
      }]
    }
  },

  computed: {
    ...mapState('apps', [
      'isModalCreateAppVisible'
    ]),

    isOpened: {
      get () {
        return this.isModalCreateAppVisible
      },

      set (v) {
        this.toggleModalVisibility(v)
      }
    },

    rules: () => ({
      name: 'required|min:2'
    })
  },

  methods: {
    ...mapActions({
      createApp: 'apps/createApp',
      toggleModalVisibility: 'apps/toggleModalCreateAppVisibility'
    }),

    destiny (app) {
      this.$router.push({ name: 'checklist-home', params: { appID: app.id } })
    }
  }
})
</script>

<style lang="scss" scoped>
  .createapp {
    width: 520px;

    select,
    :deep(input) {
      height: 50px;
      flex-basis: 50px;

      color: rgb(var(--gray8));
      font: 400 1.6rem "Nunito", sans-serif;
    }

    &__kindausage option {
      font: 400 1.8rem "Nunito", sans-serif;
    }

    &__supporttext {
      margin: 20px 0;
      color: rgb(var(--orange1));
      font: 400 1.4rem "Nunito", sans-serif;
    }

    &__submit {
      height: 50px;
      border-radius: 4px;
      margin: 40px auto 0;

      font: 700 1.8rem "Nunito", sans-serif;

      :deep(svg) {
        margin: 0 0 0 15px;
        transition: all .4s ease-in-out;
      }

      &:hover :deep(svg) {
        transform: translateX(5px);
      }
    }

    &__helperlinks {
      font: 400 1.6rem "Nunito", sans-serif;

      a {
        color: rgb(var(--gray5));
        text-decoration: underline;
      }
    }
  }
</style>
